// create a Vue global property that exposes all necessary viewport and
// device information

import DeviceDetector from 'mobile-device-detect'
import { MobileOrientation } from 'mobile-orientation'

const orientation = new MobileOrientation({
  withTouch: true,
  debounceTime: 100
})

export const DeviceDetectionProvider = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$runtimeEnvironment', {
      get: () => ({
        ...DeviceDetector, // for isMobile, isIE etc.
        isPortrait: orientation.isPortrait,
        isLandscape: orientation.isLandscape,
        onLandscape: fn => orientation.on('landscape', state => fn(state)),
        onPortrait: fn => orientation.on('portrait', state => fn(state)),
        onResize: fn => orientation.on('resize', state => fn(state))
      })
    })
  }
}